import { createResourceApi } from 'resources/ResourceApi';
import { PointOfInterestApiItem } from 'typings/api';

export default createResourceApi<PointOfInterestApiItem>('point_of_interests');
